import axios from 'utils/axios'

export const track = ({ event }, body) => {
  const endpoint = `/mixpanel/track/${event}`
  return axios.post(endpoint, body)
}
